import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import Footer from "../../../../components/LandingPage/Footer";
import invalid from "../../../../assets/CreateTransactionIcons/Skipping verivifaction.png";

const BookDemo = () => {
  const emailRef = useRef();
  const contactRef = useRef();
  const fullNameRef = useRef();
  const companyNameRef = useRef();
  const requirementRef = useRef();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [contact, setContact] = useState("");
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [requirement, setRequirement] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(null);
  const [isValidContact, setIsValidContact] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]+$/;

  const { mobilestatus, webstatus } = useSelector(
    (state) => state.landingpagestate
  );

  useEffect(() => emailjs.init("BYAIWqAyYJKmVXOHA"), []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const validateForm = () => {
    const newErrors = {};
    if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!/^\d{10}$/.test(contact)) {
      newErrors.contact =
        "Please enter a valid 10-digit contact number with +91.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEmailChange = (e) => {
    let emailValue = e.target.value.replace(/\s/g, "").toLowerCase();
    setEmail(emailValue);
    if (emailValue === "") {
      setIsValidEmail(null);
      toast.dismiss();
    } else if (emailRegex.test(emailValue)) {
      setIsValidEmail(true);
      toast.dismiss();
    } else {
      setIsValidEmail(false);
    }
  };

  const handleInputChange = (e) => {
    let contactNumber = e.target.value;
    if (/^\d{0,10}$/.test(contactNumber)) {
      setContact(contactNumber);
    }
    if (
      contactNumber.length > 0 &&
      contactNumber.length === 10 &&
      /^\d{0,10}$/.test(contactNumber)
    ) {
      setIsValidContact(true);
      toast.dismiss();
    } else {
      setIsValidContact(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const serviceId = "service_bt8vaud";
    const templateId = "template_qkqs9w6";
    try {
      await emailjs.send(serviceId, templateId, {
        fullName: fullNameRef.current.value,
        email: emailRef.current.value,
        contact: contactRef.current.value,
        companyName: companyNameRef.current.value,
        requirement: requirementRef.current.value,
      });
      toast.success(
        "Your request has been submitted successfully",
        toast_position
      );
      setFullName("");
      setEmail("");
      setContact("");
      setCompanyName("");
      setRequirement("");
    } catch (error) {
      (() => {})();
    }
  };

  const handleInvalidIconClick = (type) => {
    let message;
    switch (type) {
      case "email":
        if (!isValidEmail) {
          message = "The email you entered is invalid.";
        }
        break;
      case "contact":
        if (!isValidContact) {
          message = "The contact number you entered is invalid.";
        }
        break;
      default:
        (() => {})();
        return;
    }
    if (message) {
      toast.error(message, toast_position);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " " || e.code === "Space") {
      e.preventDefault();
    }
  };
  const buttonDisabled =
    !fullName.trim() ||
    !email.trim() ||
    !contact.trim() ||
    !companyName.trim() ||
    !requirement.trim() ||
    !emailRegex.test(email.trim()) ||
    !/^\d{10}$/.test(contact.trim());

  return (
    <>
      <div>
        {isMobile ? (
          <div>
            <div
              style={{
                overflowY: mobilestatus ? "hidden" : "auto",
                height: "100vh",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                WebkitOverflowScrolling: "touch",
              }}
              className="bg-[#031f4f]"
            >
              <div className="px-[30px] py-[30px] mt-[60px] flex flex-col gap-2.5 text-Primary_white bg-Blue_3">
                <div className="h-full max-w-[1440px] w-full flex justify-center mx-auto">
                  <div className="w-full md:w-[80%] lg:w-[50%] flex flex-col justify-center px-4 lg:pl-[125px]">
                    <h3 className="text-base font-semibold text-Primary_white">
                      Request a <span className="text-Pending">demo</span>
                    </h3>
                    <div className="rounded-2xl md:p-6">
                      <form className="mt-5" onSubmit={handleSubmit}>
                        <p className="text-Primary_grey text-sm font-semibold">
                          Request a personalised demo to explore how it can
                          streamline your operations!
                        </p>
                        <div className="grid grid-cols-1 gap-x-6 gap-y-3 md:gap-y-8 md:grid-cols-2 mt-4">
                          <div className="w-full">
                            <label
                              htmlFor="fullName"
                              className="text-xs font-medium leading-6 text-Primary_white"
                            >
                              Full name
                            </label>
                            <input
                              style={{
                                WebkitTextFillColor: "var(--Primary_white)",
                                caretColor: "var(--Primary_white)",
                              }}
                              ref={fullNameRef}
                              id="fullName"
                              name="fullName"
                              type="text"
                              value={fullName}
                              onChange={(e) => setFullName(e.target.value)}
                              placeholder="Enter your name"
                              className="custom-autofill block w-full rounded-md border border-Primary_grey bg-transparent py-1.5 px-2.5 text-xs placeholder:text-base text-Primary_grey"
                            />
                          </div>

                          <div className="w-full">
                            <label
                              htmlFor="email"
                              className={`text-xs font-medium leading-6 text-Primary_grey`}
                            >
                              Email ID
                            </label>
                            <div
                              className={`flex justify-between rounded-md border py-1.5 px-2.5 border-Primary_grey`}
                            >
                              <input
                                style={{
                                  WebkitTextFillColor: "var(--Primary_white)",
                                  caretColor: "var(--Primary_white)",
                                }}
                                ref={emailRef}
                                id="email"
                                name="email"
                                type="email"
                                value={email}
                                onKeyDown={handleKeyDown}
                                onChange={handleEmailChange}
                                placeholder="Enter your email ID"
                                className="custom-autofill block w-full text-xs placeholder:text-base bg-transparent text-Primary_grey"
                              />
                              {isValidEmail !== null && !isValidEmail && (
                                <img
                                  src={invalid}
                                  alt="Invalid"
                                  className="w-[16px] h-[16px] ml-[10px] cursor-pointer"
                                  onClick={() =>
                                    handleInvalidIconClick("email")
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 gap-x-6 gap-y-4 md:gap-y-8 md:grid-cols-2 mt-2">
                          <div className="w-full">
                            <label
                              htmlFor="contact"
                              className={`text-xs font-medium leading-6 text-Primary_white`}
                            >
                              Contact number
                            </label>
                            <div
                              className={`flex justify-between rounded-md border py-1.5 px-2.5 border-Primary_grey`}
                            >
                              <p className="text-xs placeholder:text-base text-Primary_grey mr-[2px]">
                                +91{" "}
                              </p>
                              <input
                                style={{
                                  WebkitTextFillColor: "var(--Primary_white)",
                                  caretColor: "var(--Primary_white)",
                                }}
                                ref={contactRef}
                                id="contact"
                                name="contact"
                                type="text"
                                max={10}
                                value={contact}
                                onChange={handleInputChange}
                                placeholder="Enter your contact number"
                                className="custom-autofill block w-full bg-transparent text-xs placeholder:text-base text-Primary_grey"
                              />
                              {contact.length < 10 && contact.length > 0 && (
                                <img
                                  src={invalid}
                                  alt="Invalid"
                                  className="w-[16px] h-[16px] cursor-pointer"
                                  onClick={() =>
                                    handleInvalidIconClick("contact")
                                  }
                                />
                              )}
                            </div>
                          </div>

                          <div className="w-full">
                            <label
                              htmlFor="companyName"
                              className="text-xs font-medium leading-6 text-Primary_white"
                            >
                              Company name
                            </label>
                            <input
                              style={{
                                WebkitTextFillColor: "var(--Primary_white)",
                                caretColor: "var(--Primary_white)",
                              }}
                              ref={companyNameRef}
                              id="companyName"
                              name="companyName"
                              type="text"
                              value={companyName}
                              onChange={(e) => setCompanyName(e.target.value)}
                              placeholder="Enter your company's name"
                              className="custom-autofill block w-full rounded-md border border-Primary_grey bg-transparent py-1.5 px-2.5 text-xs placeholder:text-base text-Primary_grey"
                            />
                          </div>
                        </div>

                        <div className="w-full mt-2">
                          <label
                            htmlFor="requirement"
                            className="text-xs font-medium leading-6 text-Primary_white"
                          >
                            Requirement
                          </label>
                          <textarea
                            style={{
                              WebkitTextFillColor: "var(--Primary_white)",
                              caretColor: "var(--Primary_white)",
                            }}
                            ref={requirementRef}
                            rows={8}
                            id="requirement"
                            name="requirement"
                            value={requirement}
                            onChange={(e) => setRequirement(e.target.value)}
                            placeholder="Describe your requirement"
                            className="custom-autofill block w-full rounded-md border border-Primary_grey bg-transparent py-1.5 px-2.5 text-xs placeholder:text-base text-Primary_grey"
                          />
                        </div>

                        <div className="mt-6 flex items-center justify-center md:justify-end gap-x-6">
                          <button
                            type="submit"
                            disabled={buttonDisabled}
                            className={`rounded-[50px] px-7 py-2 text-sm font-semibold ${
                              buttonDisabled
                                ? "bg-Secondary_grey text-Primary_grey"
                                : "bg-Primary_white text-Blue_3 hover:bg-Blue_7 hover:text-Primary_white"
                            }`}
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />
            </div>
          </div>
        ) : (
          <div
            style={{
              overflow: webstatus ? "hidden" : "",
              height: "100vh",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <div className="flex justify-center items-center mt-[30px] pb-[30px] bg-Blue_3">
              <div className="h-full max-w-[1440px] w-full flex justify-center mx-auto">
                <div className="w-[50%] flex flex-col justify-center">
                  <h3 className="text-center pt-[60px] pb-5 text-[28px] font-semibold text-Primary_white">
                    Request a <span className="text-Pending">demo</span>
                  </h3>
                  <div className="bg-[#314D7E] rounded-2xl">
                    <form className="p-5 mt-1" onSubmit={handleSubmit}>
                      <p className="text-Primary_grey text-sm font-semibold">
                        Request a personalised demo to explore how it can
                        streamline your operations!
                      </p>
                      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 mt-4">
                        <div className="w-full">
                          <label
                            htmlFor="fullName"
                            className="block text-[10px] font-medium leading-6 text-Primary_grey"
                          >
                            Full name
                          </label>
                          <input
                            ref={fullNameRef}
                            id="fullName"
                            name="fullName"
                            type="text"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                            placeholder="Enter your name"
                            className="block w-full rounded-md border border-Primary_grey bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-Primary_grey"
                          />
                        </div>
                        <div className="w-full">
                          <label
                            htmlFor="email"
                            className={`block text-[10px] font-medium leading-6 text-Primary_grey`}
                          >
                            Email ID
                          </label>
                          <div
                            className={`flex justify-between rounded-md border py-1.5 px-2.5 border-Primary_grey`}
                          >
                            <input
                              ref={emailRef}
                              id="email"
                              name="email"
                              type="text"
                              value={email}
                              onKeyDown={handleKeyDown}
                              onChange={handleEmailChange}
                              placeholder="Enter your email ID"
                              className="block w-full bg-transparent text-xs placeholder:text-xs text-Primary_grey"
                            />
                            {isValidEmail !== null && !isValidEmail && (
                              <img
                                src={invalid}
                                alt="Invalid"
                                className="w-[16px] h-[16px] ml-[10px] cursor-pointer"
                                onClick={() => handleInvalidIconClick("email")}
                              />
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 mt-2">
                        <div className="w-full">
                          <label
                            htmlFor="contact"
                            className="block text-[10px] font-medium leading-6 text-Primary_grey"
                          >
                            Contact number
                          </label>
                          <div className="flex justify-between rounded-md border py-1.5 px-2.5 border-Primary_grey">
                            <p className="bg-transparent text-xs placeholder:text-xs text-Primary_grey mr-[2px]">
                              +91{" "}
                            </p>
                            <input
                              ref={contactRef}
                              id="contact"
                              name="contact"
                              type="text"
                              value={contact}
                              max={10}
                              onChange={handleInputChange}
                              placeholder="Enter your contact number"
                              className="block w-full bg-transparent text-xs placeholder:text-xs text-Primary_grey"
                            />
                            {contact.length < 10 && contact.length > 0 && (
                              <img
                                src={invalid}
                                alt="Invalid"
                                className="w-[16px] h-[16px] cursor-pointer"
                                onClick={() =>
                                  handleInvalidIconClick("contact")
                                }
                              />
                            )}
                          </div>
                        </div>

                        <div className="w-full">
                          <label
                            htmlFor="companyName"
                            className="block text-[10px] font-medium leading-6 text-Primary_grey"
                          >
                            Company name
                          </label>
                          <input
                            ref={companyNameRef}
                            id="companyName"
                            name="companyName"
                            type="text"
                            value={companyName}
                            onChange={(e) => setCompanyName(e.target.value)}
                            placeholder="Enter your company's name"
                            className="block w-full rounded-md border border-Primary_grey bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-Primary_grey"
                          />
                        </div>
                      </div>

                      <div className="w-full mt-2">
                        <label
                          htmlFor="requirement"
                          className="block text-[10px] font-medium leading-6 text-Primary_grey"
                        >
                          Requirement
                        </label>
                        <textarea
                          rows={8}
                          ref={requirementRef}
                          id="requirement"
                          name="requirement"
                          type="text"
                          value={requirement}
                          onChange={(e) => setRequirement(e.target.value)}
                          placeholder="Describe your requirement"
                          className="block w-full rounded-md border border-Primary_grey bg-transparent py-1.5 px-2.5 text-xs placeholder:text-xs text-Primary_grey"
                        />
                      </div>
                      <div className="mt-6 flex items-center justify-end gap-x-6">
                        <button
                          type="submit"
                          disabled={buttonDisabled}
                          // onClick={handleSubmit}
                          className={`rounded-[50px] px-7 py-2 text-sm font-semibold ${
                            buttonDisabled
                              ? "bg-Secondary_grey text-Primary_grey cursor-default"
                              : "bg-Primary_white text-Blue_3 hover:bg-Blue_7 hover:text-Primary_white cursor-pointer"
                          }`}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        )}
      </div>
    </>
  );
};

export default BookDemo;
